import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Card as BaseCard } from '@leroy-merlin-br/backyard-react-ui'

const productsStyles = ({ theme }) => css`
  label: products;

  display: grid;
  grid-gap: ${theme.spacings.byte};
  grid-template-columns: 1fr 1fr;
  justify-items: center;

  ${theme.media.mega} {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: ${theme.spacings.mega};
  }
`

const paginationWrapper = () => css`
  label: pagination;

  align-items: center;
  display: flex;
  justify-content: center;
`

const cardStyles = ({ theme }) => css`
  @media (max-width: ${theme.breakpoints.kilo}rem) {
    & > div {
    padding: 0 ${theme.spacings.byte};
  }
}
`

export const Card = styled(BaseCard)(cardStyles)
export const Products = styled('div')(productsStyles)
export const PaginationWrapper = styled('div')(paginationWrapper)
